export default __webpack_public_path__ + "static/media/education.6fafab9b.png";